import { useIntl } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useNCWPartnerNfts } from '@capsicum/features/nc-wallet/shared';
import { NftsCarousel } from '@capsicum/socios-core-web';

import { SectionTitle, SectionWrapper } from '../NCWPartnerDetails.styled';

export const NftsSection = ({ partnerId }: { partnerId: string }) => {
	const { $t } = useIntl();
	const { push } = useRouter();

	const { isLoading, nfts } = useNCWPartnerNfts(partnerId);

	const handleClickNft = (nftId?: string) => {
		push(`/nfts/${nftId}`);
	};

	return (
		<SectionWrapper>
			<SectionTitle>{$t('ncWallet.partnerDetails.nfts.title')}</SectionTitle>

			<NftsCarousel isLoading={isLoading} nfts={nfts} onNftClick={handleClickNft} />
		</SectionWrapper>
	);
};
